import useAppStore from '../store/useAppStore.js';
import api from './apiconfig.js';

const API_URL = api.API_BASE; // Update with your backend URL

/**
 * Get all pending tokens for current branch
 * @returns {Promise<Object>} { success: boolean, tokens: Array }
 */
export const fetchPendingTokens = async () => {
  try {
    const token = useAppStore.getState().user?.token || localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}/orders/tokens/pending`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch pending tokens');
    }

    return data;
  } catch (error) {
    console.error('Error fetching pending tokens:', error);
    throw error;
  }
};

/**
 * Update token status
 * @param {number} orderId - Order ID
 * @param {string} status - Token status (issued, called, completed, cancelled)
 * @param {string} note - Optional note
 * @returns {Promise<Object>} { success: boolean, events: Array }
 */
export const updateTokenStatus = async (orderId, status, note = null) => {
  try {
    const token = useAppStore.getState().user?.token || localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}/orders/${orderId}/token/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        status,
        note
      })
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to update token status');
    }

    return data;
  } catch (error) {
    console.error('Error updating token status:', error);
    throw error;
  }
};

export const fetchAdminTokens = async () => {
  try {
    const token = useAppStore.getState().user?.token || localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const response = await fetch(`${API_URL}/orders/tokens`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch admin tokens');
    }

    return data;
  } catch (error) {
    console.error('Error fetching admin tokens:', error);
    throw error;
  }
};
